import React from "react";


const Wrapper = props => <div className="container">{props.children}</div>;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/wrapper.js